/**
 * trønso: Newsletter-Popup (sections/tronso-newsletter-popup.liquid).
 *
 * Öffnet das Fenster, sobald der Besucher die eingestellte Zeit auf der Website verbracht hat.
 * Der Startzeitpunkt liegt im sessionStorage, die Zeit läuft also über Seitenwechsel weiter. Ist
 * es einmal erschienen, merkt sich der localStorage das pro Kennung, danach kommt es nicht wieder.
 * Lässt sich der Merker nicht schreiben (Speicher gesperrt), bleibt das Popup ganz weg, statt auf
 * jeder Seite neu aufzutauchen.
 *
 * Gewartet wird, solange der Tab im Hintergrund ist oder schon ein anderes Fenster offen ist
 * (Warenkorb, Menü, andere Popups), auf ein offenes Cookie-Banner höchstens 15 s.
 *
 * Abgeschickt wird über tronso-newsletter.js ohne Neuladen. Fällt das auf normales Abschicken
 * zurück (Captcha), kommt der Besucher mit ?customer_posted=true zurück; dann öffnet sich das
 * Popup sofort mit der Dankesmeldung, aber nur, wenn die Anmeldung wirklich aus dem Popup kam.
 *
 * Im Theme-Editor öffnet es sich nie von selbst, nur wenn die Section ausgewählt ist.
 */
(() => {
  if (window.tronsoNewsletterPopup) return;
  window.tronsoNewsletterPopup = true;

  const START = 'tronso-newsletter-popup-start';
  const GESEHEN = 'tronso-newsletter-popup-gesehen:';
  const GESENDET = 'tronso-newsletter-popup-gesendet';
  const NOCHMAL = 3000;

  const dialogHolen = () => document.querySelector('dialog.tronso-nl-popup');

  const lesen = (speicher, key) => {
    try {
      return window[speicher].getItem(key);
    } catch (e) {
      return null;
    }
  };

  const schreiben = (speicher, key, wert) => {
    try {
      window[speicher].setItem(key, wert);
      return window[speicher].getItem(key) === wert;
    } catch (e) {
      return false;
    }
  };

  const entfernen = (speicher, key) => {
    try {
      window[speicher].removeItem(key);
    } catch (e) {
      /* egal */
    }
  };

  // Schließen per Schleier und per Button nach der Anmeldung. Einmal pro Dialog-Element, weil der
  // Editor die Section beim Bearbeiten neu rendert. Der Button wird nach dem Abschicken neu
  // eingesetzt, deshalb per Delegation.
  const einrichten = (dialog) => {
    if (dialog.dataset.tronsoBereit) return;
    dialog.dataset.tronsoBereit = '1';

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-schliessen]')) dialog.close();
    });

    // Merken, dass aus dem Popup abgeschickt wurde (für den Rückfall mit Neuladen).
    dialog.addEventListener('submit', (e) => {
      if (e.target.matches('[data-tronso-popup-form]')) schreiben('sessionStorage', GESENDET, '1');
    });
  };

  const zeigen = (dialog) => {
    einrichten(dialog);
    if (!dialog.open) dialog.showModal();
  };

  // ---- Theme-Editor ---------------------------------------------------------------------------
  if (window.Shopify && window.Shopify.designMode) {
    const passt = (e) => {
      const dialog = dialogHolen();
      return dialog && e.detail && dialog.dataset.sectionId === e.detail.sectionId ? dialog : null;
    };
    document.addEventListener('shopify:section:select', (e) => {
      const dialog = passt(e);
      if (dialog) zeigen(dialog);
    });
    document.addEventListener('shopify:section:load', (e) => {
      const dialog = passt(e);
      if (dialog) zeigen(dialog);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const dialog = passt(e);
      if (dialog && dialog.open) dialog.close();
    });
    return;
  }

  // ---- Shop -----------------------------------------------------------------------------------
  const dialog = dialogHolen();
  if (!dialog) return;
  const kennung = dialog.dataset.kennung || '';
  if (!kennung) return;

  // Rückkehr nach normalem Abschicken: Dank bzw. Fehler sofort zeigen.
  if (lesen('sessionStorage', GESENDET)) {
    entfernen('sessionStorage', GESENDET);
    if (/[?&]customer_posted=true/.test(window.location.search) || dialog.querySelector('[aria-invalid="true"]')) {
      zeigen(dialog);
      return;
    }
  }

  // Aktion vorbei? Das Liquid prüft es auch, aber eine zwischengespeicherte Seite kann älter sein.
  const tag = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dialog.dataset.letzterTag || '');
  if (tag && Date.now() >= new Date(+tag[1], +tag[2] - 1, +tag[3] + 1).getTime()) return;

  if (lesen('localStorage', GESEHEN + kennung)) return;

  let start = parseInt(lesen('sessionStorage', START), 10);
  if (!start) {
    start = Date.now();
    if (!schreiben('sessionStorage', START, String(start))) return;
  }

  const sichtbar = (el) => {
    if (!el) return false;
    const stil = getComputedStyle(el);
    return stil.display !== 'none' && stil.visibility !== 'hidden' && el.getClientRects().length > 0;
  };

  // Auf das Cookie-Banner wird nur begrenzt gewartet. Seit es eine schmale Leiste ist
  // (snippets/tronso-cookie-banner.liquid), scrollen viele einfach weiter, ohne es zu beantworten;
  // ohne Obergrenze käme das Popup dann nie. Das Popup liegt danach über dem Banner, das Banner
  // bleibt unverändert stehen.
  const BANNER_MAX = 15000;
  let bannerSeit = 0;
  const bannerBlockiert = () => {
    if (!sichtbar(document.getElementById('shopify-pc__banner'))) return false;
    if (!bannerSeit) bannerSeit = Date.now();
    return Date.now() - bannerSeit < BANNER_MAX;
  };

  const blockiert = () =>
    document.hidden ||
    bannerBlockiert() ||
    Boolean(document.querySelector('dialog[open]:not(.tronso-nl-popup)'));

  const versuchen = () => {
    if (!dialog.isConnected || dialog.open) return;
    if (lesen('localStorage', GESEHEN + kennung)) return;
    if (blockiert()) {
      setTimeout(versuchen, NOCHMAL);
      return;
    }
    if (!schreiben('localStorage', GESEHEN + kennung, String(Date.now()))) return;
    zeigen(dialog);
  };

  const rest = Number(dialog.dataset.verzoegerung || 30) * 1000 - (Date.now() - start);
  setTimeout(versuchen, Math.max(0, rest));
})();
